import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CNDisease } from '../models/cndisease';
import { CNVaccine } from '../models/cnvaccine';
import { SNItemFactory } from '../models/snitemfactory';
import { BecareService } from './becare.service';

@Injectable({
  providedIn: 'root'
})
export class VaccinationService {

  public diseasesSubject: BehaviorSubject<CNDisease[]> = new BehaviorSubject([]);
  public vaccinesSubject: BehaviorSubject<CNVaccine[]> = new BehaviorSubject([]);

  constructor(private becare: BecareService) { }

  public loadDiseases(): void {
    this.becare.call('/fr/vaccination/diseases').subscribe(result => {
      if (result.success === true && result.diseases !== undefined) {
        const factory = new SNItemFactory();
        this.diseasesSubject.next(factory.itemsFromJson(result.diseases));
      }
    });
  }

  public loadVaccines(): void {
    this.becare.call('/fr/vaccination/vaccines').subscribe(result => {
      if (result.success === true && result.vaccines !== undefined) {
        const factory = new SNItemFactory();
        this.vaccinesSubject.next(factory.itemsFromJson(result.vaccines));
      }
    });
  }

  get diseases(): BehaviorSubject<CNDisease[]> {
    if (this.diseasesSubject.getValue().length === 0) {
      // Load diseases
      this.loadDiseases();
    }
    return this.diseasesSubject;
  }

  get vaccines(): BehaviorSubject<CNVaccine[]> {
    if (this.vaccinesSubject.getValue().length === 0) {
      // Load vaccines
      this.loadVaccines();
    }
    return this.vaccinesSubject;
  }
}
